import { PlayerPortalsIDCard } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export default {
  component: () => PlayerPortalsIDCard,
  mapEntryToProps: (entry: PLAYER_PORTALS_MODELS.IDCard) =>
    kontentAiDataMapping.player_portals_id_card(entry),
};
